import React from 'react';
import { useAllBadgeList } from '../../hooks';
import { BadgeList } from '../../components/BadgeList';
import styles from './index.module.scss';

export default () => {
  const { data, isLoading, isError, refetch } = useAllBadgeList();
  return (
    <BadgeList
      data={data}
      refetch={refetch}
      isLoading={isLoading}
      isError={isError}
      className={styles.listContainer}
      showBadgeIssuedInfo
    />
  );
};
